import Page from './PlanSearchPage';

export default Page;
